export const LOADING_VIEW = () => {
  return (
    <>
      <div className="sl-pb-6 sl-text-center">
        <h1 className="sl-fonts">Loading...</h1>
      </div>
      <p className="sl-text-lg sl-text-center">Please wait</p>
    </>
  )
}

export default LOADING_VIEW
